import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { HrReportScreen } from '@/features/hr-reports/report-screen'
import { hasGrant } from '@/lib/me'
export const Route = createFileRoute('/_authenticated/hr/reports/payroll-register')({
  validateSearch: (search: Record<string, unknown>) => hrReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'payroll_report.view')) throw redirect({ to: '/hr' })
  },
  component: PayrollRegisterRoute,
})
function PayrollRegisterRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <HrReportScreen
      report="payroll-register"
      search={search}
      onSearchChange={(next) => void navigate({ to: '/hr/reports/payroll-register', search: next })}
    />
  )
}
